(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/lotto.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/lotto.js');

'use strict';

var _svs$numbergames;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const LOTTO = {
  productId: (_svs$numbergames = svs.numbergames) === null || _svs$numbergames === void 0 || (_svs$numbergames = _svs$numbergames.productMapping) === null || _svs$numbergames === void 0 ? void 0 : _svs$numbergames.CONSTANTS.LOTTO,
  rowPrice: 4,
  rowPriceMultipliers: [1],
  numbersMaxValue: 35,
  numbersMaxLength: 7,
  maxNumberOfRows: 15,
  usesJoker: true,
  defaultJokerPrice: 10,
  hasLotto2: true,
  rowPriceMulti: [2],
  winConditions: [{
    numbers: 4
  }],
  hasSubscription: true,
  possibleDrawCounts: [{
    value: '1',
    label: '1 v'
  }, {
    value: '2',
    label: '2 v'
  }, {
    value: '3',
    label: '3 v'
  }, {
    value: '4',
    label: '4 v'
  }, {
    value: '5',
    label: '5 v'
  }, {
    value: '6',
    label: '6 v'
  }, {
    value: '7',
    label: '7 v'
  }, {
    value: '8',
    label: '8 v'
  }, {
    value: '9',
    label: '9 v'
  }, {
    value: '10',
    label: '10 v'
  }],
  PACKAGES: {
    50: {
      rows: 5,
      hasJoker: true,
      jokerPrice: 10
    },
    130: {
      rows: 15,
      hasJoker: true,
      jokerPrice: 10
    },
    260: {
      rows: 30,
      hasJoker: true,
      jokerPrice: 20
    }
  },
  SYSTEM: {
    LIMITS: {
      NUMBERS: {
        minRowLength: 8,
        maxRowLength: 12,
        combinationMinLength: {},
        combinationMaxLength: {}
      }
    }
  }
};
const LOTTO_SELFSERVICE = _objectSpread(_objectSpread({}, LOTTO), {}, {
  possibleDrawCounts: [{
    value: '1',
    label: '1 v'
  }, {
    value: '2',
    label: '2 v'
  }, {
    value: '5',
    label: '5 v'
  }, {
    value: '10',
    label: '10 v'
  }]
});
if (svs.isServer) {
  module.exports = {
    LOTTO,
    LOTTO_SELFSERVICE
  };
} else {
  svs.numbergames.rules.LOTTO = LOTTO;
  svs.numbergames.rules.LOTTO_SELFSERVICE = LOTTO_SELFSERVICE;
}

 })(window);